import Vue from 'vue'
import VueResource from 'vue-resource'
import router from './router'
import store from './store'
import {sync} from 'vuex-router-sync'
import * as filters from './filters'
import {auth, auth as authService} from './services'
import NProgress from 'nprogress'
import Dashboard from './layouts/Dashboard.vue'
import DashboardMobile from './layouts/DashboardMobile'
import Auth from './layouts/Auth.vue'
import Maintenance from './layouts/Maintenance.vue'
import VModal from 'vue-js-modal';
import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
import money from 'v-money'
import VueTranslate from 'vue-translate-plugin';
import lang from './services/lang';
import VueCurrencyFilter from 'vue-currency-filter';
import Translate from "@/mixins/Translate.vue";
import FilterMixins from './mixins/FilterMixins';
import FileDownloader from "./mixins/FileDownloader";
import {ResourcesService} from "./services/resources/ResourcesService";
import {DumpMethodFilterProvider} from "./services/resources/filterProvider/DumpMethodFilterProvider";
import EventManager from "./services/eventManager/EventManager.ts";
import EventSourceService from "./services/EventSourceService.ts";
import ComponentService from "./services/components/ComponentService.ts";
import DataLoader from "@/services/DataLoader.ts";
import ValueChecker from "@/services/ValueChecker";

Vue.use(VueCurrencyFilter,
    {
        symbol: '',
        thousandsSeparator: ' ',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'end',
        symbolSpacing: true
    })


Vue.use(VueTranslate);

Vue.use(money, {
    decimal: ',',
    thousands: '',
    prefix: '',
    precision: 2,
    masked: true,
});
Vue.use(VueResource);
Vue.use(VModal, {dialog: true});

Vue.use((() => function install(Vue, options) {
    Vue.prototype.$env = require(`./env/${APP_ENV}.js`)
})())

sync(store, router)

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

const app = new Vue({
    // el: '#app',
    router,
    store,
    provide() {
        return {
            eventManager: new EventManager(this, this.$http),
            eventSourceService: new EventSourceService(this.$env.API_URL + '/event-source/pull', this),
            componentService: new ComponentService(),
        }
    },
    created() {
        this.initServices();
        this.initHttp();
    },
    async mounted() {
        await lang.initLocale(this, this.$http);
        this.$emit('project-metadata-ready', this.$projectMetadata);
        this.$emit('user-metadata-ready', this.$userMetadata);
        this.$emit('menu-ready', this.$menu);
        this.$emit('user-menu-ready', this.$userMenu);
        this.mountEvents();
    },
    render(h) {
        if (auth.isUnavailable()) {
            return h(Maintenance);
        }

        if (auth.isLogged()) {
            if (auth.isMobile()) {
                return h(DashboardMobile);
            }

            return h(Dashboard);
        }

        return h(Auth);
    },
    methods: {
        getMenu() {
            return router.getMenu();
        },
        mountEvents() {
            this.$on('show-confirm-modal', (config, data) => {
                this.showConfirmModal(config.message, config.callback);
            });
            this.$on('show-modal', (config, data) => {
                this.showModal(config.message, config.title);
            });
        },
        showInfoModal(text) {
            this.showModal(text, this.$translate.text('Info!'));
        },
        showErrorModal(text) {
            this.showModal(text, `${this.$translate.text('Error')}!`);
        },
        showModal(text, title, type) {
            let typeN = type || 'dialog';
            this.$modal.show(typeN, {
                title: this.$translate.text(title),
                text: this.$translate.text(text),
                buttons: [{
                    title: 'Ok'
                }]
            });
        },
        showConfirmModal(message, callback) {
            this.$confirm({
                message: this.$translate.text(message),
                button: {
                    no: this.$translate.text('No'),
                    yes: this.$translate.text('Yes')
                },
                callback: confirm => {
                    if (confirm) {
                        callback();
                    }
                }
            });
        },
        showConfirmModalResolve(message, callback) {
            this.$confirm({
                message: this.$translate.text(message),
                button: {
                    no: this.$translate.text('No'),
                    yes: this.$translate.text('Yes')
                },
                callback: confirm => {
                    callback(confirm);
                }
            });
        },
        initHttp() {
            let _this = this;
            Vue.http.interceptors.push((request, next) => {
                next((response) => {
                    switch (response.status) {
                        case 401:
                            authService.logout(_this, function () {
                                window.location.href = router.getSignInLink();
                            });
                            break;
                        case 400:
                        case 429:
                            if (!response.data.message) {
                                return;
                            }

                            app.$modal.show('dialog', {
                                title: `${this.$translate.text('Error')}!`,
                                text: this.$translate.text(response.data.message),
                                buttons: [
                                    {title: this.$translate.text('Close')}
                                ]
                            });
                            break;
                        case 500:
                            app.$modal.show('dialog', {
                                title: `${this.$translate.text('Attention')}!`,
                                text: 'Wystąpił błąd podczas przetwarzania danych. Jeśli problem będzie się powtarzać, proszę zgłosić to administratorowi.',
                                buttons: [
                                    {
                                        title: 'Ponów próbę.', handler: () => {
                                            window.location.reload();
                                        }
                                    },
                                    {title: this.$translate.text('Close')}
                                ]
                            });
                            break;
                        case 503:
                            if (!response.url.includes('/menu/get')) {
                                window.location = '/';
                            }
                            break;
                    }
                });
            });

            Vue.http.interceptors.push((request, next) => {
                if (!(typeof request.showProgressBar !== 'undefined' && request.showProgressBar === false)) {
                    NProgress.start()
                    // this.store.commit('showOverlay')
                    next((response) => {
                        NProgress.done();
                        if (response.status === 0) {
                            NProgress.start();
                        }
                        // this.store.commit('hideOverlay')
                    });
                }
            });

            Vue.http.options.root = this.$env.API_URL;
            Vue.http.options.credentials = true;

            if (!ValueChecker.isUndefinedOrNullOrIsEmpty(lang.current())) {
                Vue.http.headers.common['Accept-Language'] = lang.current();
            }

            Vue.http.headers.common['Content-Type'] = 'application/json; charset=utf-8'
            if (auth.getAuthHeader()) {
                Vue.http.headers.common['Authorization'] = auth.getAuthHeader()
            }

            Vue.http.options.error = (p1, p2, p3, p4) => {
                console.log('error');
                console.log(p1, p2, p3, p4);
            };

            /** Abort previous request */
            Vue.http.interceptor.before = (request) => {
                this.resourceService.cancelByHash(request);
                this.resourceService.collect(request);
            };

            /** Abort previous requests */
            Vue.http.abortPrevRequests = () => {
                this.resourceService.cancelAll();
            };
        },
        initServices() {
            this.componentService = null;
            this.resourceService = new ResourcesService();
            this.resourceService.addFilterProvider(new DumpMethodFilterProvider());
            this.dataLoader = {};
        },
        getEventManager() {
            if (!this.eventManager) {
                this.eventManager = new EventManager(this, this.$http);
            }


            return this.eventManager;
        },
        getComponentService() {
            if (!this.componentService) {
                this.componentService = new ComponentService();
            }

            return this.componentService;
        },
        getDataLoader(config) {
            if (!this.dataLoader[config.index]) {
                this.dataLoader[config.index] = new DataLoader(this, this.$http, config);
            }

            return this.dataLoader[config.index];
        }
    },
    watch: {
        $route(from, to) {
            if (from === to) {
                return;
            }

            this.$emit('change-route-event', to, from);
        }
    },
});

Vue.mixin(FilterMixins);
Vue.mixin(FileDownloader);
Vue.mixin(Translate);

app.getMenu().then((q, w) => {
    app.$mount('#app');
}, (response) => {
    if (response.status === 503) {
        authService.markUnavailable();
        app.$mount('#app');
    }
});


export {app, router/*, store*/}



// WEBPACK FOOTER //
// ./src/app.js